// use client: `year` tab state with onClick handlers
'use client'

import './ImportantNotices.css'

import { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'

import Link from '@/components/Link'
import { parseCmsHtml } from '@/utils'

// Notice dates come from two sources: CMS ('DD MMM YYYY') and legacy JSON ('D MMM YYYY').
// Parsing the sort key with these explicit formats avoids moment's locale-dependent
// non-ISO fallback (and the build-time deprecation warning).
const NOTICE_DATE_FORMATS = ['DD MMM YYYY', 'D MMM YYYY']

const getYearList = step => {
  const currentYear = new Date().getFullYear()
  return Array.from(
    { length: (currentYear - 1 - currentYear) / step + 2 },
    (_, i) => currentYear + i * step
  )
}

const NOTICE_SKELETON_COUNT = 6

const ImportantNotices = ({ initialData }) => {
  // Seeded at build time and already includes the legacy JSON notices, deduped
  // against the CMS in app/important-notices/page.tsx.
  // Content comes from the build-time snapshot only. Every caller now seeds
  // `initialData`, so the old `if (!initialData)` fetch branch was dead. A Strapi
  // publish rebuilds and redeploys the site, so there is nothing to revalidate on
  // mount. See tests/no-client-cms-fetch.spec.ts.
  const importantNoticeListCms = initialData ?? []
  const isLoading = !initialData

  const [year, setYear] = useState(new Date().getFullYear().toString())

  return (
    <div className="important-notices container my-5">
      <div className="heading">Important Notices</div>
      <div className="year-selector">
        {getYearList(-1).map(y => (
          <button
            key={y}
            className={`year-btn ${year === y.toString() ? `active` : ``}`}
            onClick={() => setYear(y.toString())}
          >
            {y.toString()}
          </button>
        ))}
      </div>
      <Row className="notice-list">
        {isLoading
          ? Array.from({ length: NOTICE_SKELETON_COUNT }).map((_, i) => (
              <Col md={4} key={i}>
                <div className="notice-card" style={{ background: '#f5f5f5' }} />
              </Col>
            ))
          : [...importantNoticeListCms]
              .sort(
                (a, b) =>
                  moment(b.date, NOTICE_DATE_FORMATS).valueOf() -
                  moment(a.date, NOTICE_DATE_FORMATS).valueOf()
              )
              .filter(notice => notice.tag === year)
              .map(notice => {
                return (
                  <Col md={4} key={notice.slug}>
                    <Link
                      href={`/important-notice-detail/${notice.slug}`}
                      className="notice-card"
                      style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                    >
                      <div className="title">{notice.title}</div>
                      <div className="subtitle">
                        {parseCmsHtml(notice.content, { stripLinks: true })}
                      </div>
                      <div className="cta-date">
                        <span className="read-more">Read more</span>
                        <div className="date">{notice.date}</div>
                      </div>
                    </Link>
                  </Col>
                )
              })}
      </Row>
    </div>
  )
}

export default ImportantNotices
